<template>
  <aside class="user-profile-sidebar d-flex offset-xl-1 col-xl-3 col-lg-3 col-xxs-12 bg-white flex-column p-0 text-dark">
    <div class="avatar-bg justify-content-center" />
    <span class="d-flex avatar position-relative rounded-circle avatar-shadow p-1 bg-white align-self-center justify-content-end">
      <img height="128" src="@/assets/icons/avatar.svg">
      <b-dropdown variant="link" size="lg" no-caret class="position-absolute align-self-end d-flex justify-self-center">
        <template slot="button-content">
          <img src="@/assets/icons/cog.svg" height="24" class="bg-light p-0 border border-white rounded-circle">
          <span class="sr-only">
            Cog
          </span>
        </template>
        <b-dropdown-item href="#" class="d-flex align-self-start" @click="EditUser()">
          {{ $t('UserProfile.Commands.EditUser') }}
        </b-dropdown-item>
        <b-dropdown-item v-if="false" href="#" class="d-flex align-self-start" @click="EditUserAccountInfo()">
          {{ $t('UserProfile.Commands.EditUserAccountInfo') }}
        </b-dropdown-item>
      </b-dropdown>
    </span>
    <UserProfileDemographic v-if="!InEditMode && ((this.isNavigationVisible && this.activeTab == this.profileTab.Demographic) || !this.isNavigationVisible)" :user="user" />
    <UserProfileEditDemographic v-if="(InEditMode && InEditDemographicInfoMode) && ((this.isNavigationVisible && this.activeTab == this.profileTab.Demographic) || !this.isNavigationVisible)" :user="user" @HideEditForm="HideEditForm" />
    <UserProfileEditUserAccount v-if="(InEditMode && InEditUserAccountInfoMode) && ((this.isNavigationVisible && this.activeTab == this.profileTab.Demographic) || !this.isNavigationVisible)" :user="user" @HideEditUserAccountForm="HideEditUserAccountForm" />
  </aside>
</template>

<script>
import UserProfileEditDemographic from '@/components/UserProfileEditDemographic.vue'
import UserProfileEditUserAccount from '@/components/UserProfileEditUserAccount.vue'
import UserProfileDemographic from '@/components/UserProfileDemographic.vue'
import enums from '@/utilities/enums.js'
import { mapGetters } from 'vuex'

export default {
  name: 'UserProfileSidebar',
  components: {
    UserProfileEditDemographic,
    UserProfileEditUserAccount,
    UserProfileDemographic
  },
  mixins: [enums],
  props: {
    user: Object,
    isNavigationVisible: Boolean,
    activeTab: String
  },
  computed: {
    ...mapGetters({

    })
  },
  data () {
    return {
      InEditUserAccountInfoMode: false,
      InEditDemographicInfoMode: false,
      InEditMode: false
    }
  },
  methods: {
    ResetAllFlags () {
      this.InEditUserAccountInfoMode = false,
      this.InEditDemographicInfoMode = false,
      this.InEditMode = false
    },
    EditUser () {
      this.ResetAllFlags()
      this.InEditDemographicInfoMode = true
      this.InEditMode = true
    },
    HideEditForm () {
      this.ResetAllFlags()
      this.InEditDemographicInfoMode = false
      this.InEditMode = false
      this.SetInitialData()
    },
    EditUserAccountInfo () {
      this.ResetAllFlags()
      this.InEditUserAccountInfoMode = true
      this.InEditMode = true
    },
    HideEditUserAccountForm () {
      this.ResetAllFlags()
      this.InEditUserAccountInfoMode = false
      this.InEditMode = false
    },
    SetInitialData () {
      this.$emit('SetInitialData')
    }
  }
}
</script>
